<ng-container *transloco="let t; read: 'session.404'">
  <div class="text-wrapper p-4">
    <a [href]="t('url')" target="_blank">
      <img class="logo" src="assets/images/Paperless_Logo-maindark.svg">
    </a>
    <h4 class="mb-2">{{t('header')}}</h4>
    <p class="text-muted">{{t('subheader')}}</p>
  </div>
</ng-container>
